import { useEffect, useState } from "react"
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts"
import CustomTooltip from "../DemandForecast/PieChartComponents/CustomTooltip"
import DepthAndRogWeightages from "./Utils/DepthAndRogWeightages.js"


const COLORS = [
  "#8884d8", "#82ca9d", "#FFBB28", "#FF8042", "#AF19FF"
]


const DemandPieCharts = ({ trends, demandForecastType, salesTarget, setShowImagesPopup, NATrends }) => {

  const [displayTrends, setDisplayTrends] = useState([])


  const onClickHandler = (trend) => {
    setShowImagesPopup({ tag: trend.trendTag, value: trend.trendValue, trendType: 'social' })
  };

  useEffect(() => {
    const { ROG, depth } = DepthAndRogWeightages(demandForecastType)
    let targetTrends = []
    trends.forEach(trend => {
      const newTrend = {
        tag: trend.tag,
        value: trend.value,
        trendTag: trend.tag,
        trendValue: trend.value,
        depth: trend.depth,
        rateOfGrowth: trend.rateOfGrowth,
        score: ROG * trend.rateOfGrowth + depth * trend.depth,

      }
      targetTrends.push(newTrend);
    })
    if (NATrends) {
      NATrends.forEach(trend => {
        const newTrend = {
          tag: trend.tag,
          value: trend.value,
          trendTag: trend.tag,
          trendValue: trend.value,
          depth: trend.depth,
          rateOfGrowth: trend.rateOfGrowth,
          score: ROG * trend.rateOfGrowth + depth * trend.depth,

        }
        targetTrends.push(newTrend);
      })
    }
    //    targetTrends = targetTrends.filter(t => t.score > 0);
    const scoreSum = targetTrends.reduce((prev, current) => {
      return prev + current.score;
    }, 0)

    targetTrends.forEach(trend => {
      trend.sales = Math.round(trend.score * salesTarget / scoreSum)
    })

    targetTrends = targetTrends.sort((a, b) => {
      return b.sales - a.sales
    })

    setDisplayTrends(targetTrends)
  }, [trends, demandForecastType, salesTarget])

  return <><div className="w-full h-[30rem] ">
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={'100%'} height={'100%'} >
        <Tooltip content={<CustomTooltip />} cursor={{ fill: "transparent" }} />
        <Pie
          data={displayTrends}
          dataKey="sales"
          outerRadius={160}
          cx="50%"
          cy="50%"
          onClick={onClickHandler}
        >
          {displayTrends.map((trend, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  </div>
  </>
}

export default DemandPieCharts
